module.exports = (__webpack_require__(2))(219)


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/@angular/router/@angular/router.es5.js from dll-reference vendor_lib
// module id = 30
// module chunks = 4